import {
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_ERROR,
  AUTH_REFRESH,
  AUTH_GET_ME,
  AUTH_CANCEL_SUBSCRIPTION
} from '../types';
import firebase from 'firebase'

const state = {
  currentUser: null,
  isLoading: false,
  error: null
};

const getters = {
  getCurrentUser: (state) => state.currentUser,
  isAuthLoading: (state) => state.isLoading,
}

const actions = {
  [AUTH_GET_ME]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      const getMe = firebase.functions().httpsCallable('getMe')
      getMe()
        .then((response) => {
          console.log(response)
          commit(AUTH_SUCCESS, { user: response.data });
          resolve(response);
        })
        .catch((err) => {
          console.log(err)
          commit(AUTH_ERROR);
          reject();
        })
    })
  },
  [AUTH_CANCEL_SUBSCRIPTION]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      const cancel = firebase.functions().httpsCallable('cancelSubscription')
      cancel()
        .then((response) => {
          console.log(response)
          commit(AUTH_SUCCESS, { user: response.data });
          resolve(response);
        })
        .catch((err) => {
          console.log(err)
          commit(AUTH_ERROR);
          reject();
        })
    })
  },
  [AUTH_REFRESH]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);

      firebase.auth().onAuthStateChanged((user) => {
        if (!user) {
          commit(AUTH_ERROR);
          reject();
        } else {
          const getMe = firebase.functions().httpsCallable('getMe')
          getMe()
            .then((response) => {
              commit(AUTH_SUCCESS, { user: response.data });
              resolve(response);
            })
            .catch((err) => {
              console.log(err)
              commit(AUTH_ERROR);
              reject();
            })

        }
      })
    });
  }
}

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.isLoading = true;
  },
  [AUTH_SUCCESS]: (state, { user }) => {
    state.isLoading = false;
    if (user) state.currentUser = user;
  },
  [AUTH_ERROR]: (state, error) => {
    state.isLoading = false;
    state.currentUser = null;
  }
}

export default {
  state,
  getters,
  actions,
  mutations
};
